import {IVanillaReaderUI} from './IVanillaReaderUI';
import {IVanillaReaderUiComponentController} from './IVanillaReaderUiComponentController';
import {VanillaReaderUI} from './VanillaReaderUI';
import {IVanillaReaderAppEvent_NAVIGATION_INTENT} from '../VanillaReaderEventBus/IVanillaReaderAppEventTypeMap';

export interface VanillaReaderUiDialogNavigationHistoryController extends IVanillaReaderUiComponentController, IVanillaReaderUI {
}

/**
 * # VanillaReaderUiDialogNavigationHistoryController
 *
 * ## RESPONSIBILITIES
 * This controller mixing class handles all event callbacks from the `VanillaReaderUiDialogNavigationHistory` class.
 *
 * Just as all other controller mixin classes, this class is used to add functionality to the `VanillaReaderUi` class
 * in a "modular" way. Read more about this in the `UI Components and Controller Mixins` in the README.md file.
 *
 * ## RELATED TYPES
 * - VanillaReaderUi
 * - VanillaReaderUiDialogNavigationHistory
 *
 * */
export class VanillaReaderUiDialogNavigationHistoryController {

    static __initialize__(vanillaReaderUiContext: VanillaReaderUI): void {
        vanillaReaderUiContext.dialogNavigationHistory.onHistoryItemClicked(vanillaReaderUiContext._onDialogNavigationHistoryItemClicked.bind(vanillaReaderUiContext));
    }

    _onDialogNavigationHistoryItemClicked(navigationData: IVanillaReaderAppEvent_NAVIGATION_INTENT): void {
        if (navigationData.locator) {
            this.navigateTo(navigationData.locator.toString());
        }

        this.dialogNavigationHistory?.close();
    };

}
